import { useEffect } from "react";

export const useSuccess = (successSelector: any, message: any, onSuccess: any) => {

  useEffect(() => {
    if (successSelector) {
      if (message) {
        //console.log(message)
      }

      if (onSuccess) onSuccess(successSelector);
    }
    //eslint-disable-next-line
  }, [successSelector, message]);
};

export const useFailed = (failedSelector: any, message: any, onFailed: any) => {
  // const failed = useSelector(failedSelector);
  //console.log('failedSelector', failedSelector);
  
  useEffect(() => {
    if (failedSelector) {
      //console.log(26, message, failedSelector)
    }

    if (onFailed && failedSelector) onFailed(failedSelector);
  //eslint-disable-next-line
  }, [failedSelector, message]);
};

export const obsceneWords = new Set([
  "địt mẹ", "đụ má", "lồn con", "điếm", "đỉ", "đụ", "cặc", "lồn", "đĩ", "địt", "đéo", "con mẹ nó", "mẹ mày", "má mày",
  "개년", "미친년", "좆", "개자식", "씨발", "개새끼", "미친", "병신", "지랄",
  "motherfucking", "ass", "damn", "shithead", "fuck", "shit", "asshole", "bitch", "motherfucker"
]);

export const checkForObsceneWords = (value: string) =>{
  // Chuyển đổi giá trị nhập vào và từng từ trong mảng obsceneWords về chữ thường để so sánh
  const words = value.toLowerCase().split(' ');
  for (const word of words) {
    if (obsceneWords.has(word)) {
      // Nếu tìm thấy từ bị cấm, trả về true
      return true;
    }
  }
  // Nếu không tìm thấy từ bị cấm, trả về false
  return false;
}